class SearchForm extends HTMLElement {
  constructor() {
    super();
    console.log(222111)
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  connectedCallback() {

    // 找到包裹它的 details（搜索弹层）
    this.details = this.closest('details');
    this.modal = this.closest('.search-modal');
    let supportListTrigger = document.getElementById('header-explore-list-trigger');
    
    const modalToggleClose = document.querySelector('.modal__toggle-close'); 
    const modalToggleCloseBtn = document.querySelector('.modal__toggle-close_btn'); 

    const modalToggleOpen = document.querySelector('.modal__toggle-open'); 
    if (!this.details || !this.modal) return;
    this.modal.addEventListener('mouseleave', () => {
      this.details.removeAttribute('open');
    });

    supportListTrigger?.addEventListener('mouseover', (event) => {
       this.details.removeAttribute('open');
    });
    this.detailsObserver = new MutationObserver(() => {
      if (this.details.hasAttribute('open')) {
        this.onSearchOpen();
      } else {
        this.onSearchClose();
      }
    });

    this.detailsObserver.observe(this.details, {
      attributes: true,
      attributeFilter: ['open']
    });


    modalToggleClose.addEventListener('click', () => {
      event.stopPropagation(); // 阻止事件冒泡
      event.preventDefault();  // 阻止默认行为
      if (window.innerWidth < 1200) {
        this.details.removeAttribute('open');
        modalToggleOpen.style.display = 'block';
        modalToggleClose.style.display = 'none';
        modalToggleCloseBtn.style.display = 'none';
      }
    });

  }

  disconnectedCallback() {
    // 组件卸载时清理 observer（防内存泄漏）
    this.detailsObserver && this.detailsObserver.disconnect();
  }

  onSearchOpen() {
    console.log('搜索展开');
    let headerMask = document.getElementById('header-mask');
    const modalToggleOpen = document.querySelector('.modal__toggle-open'); 
    const modalToggleClose = document.querySelector('.modal__toggle-close'); 
    const modalToggleCloseBtn = document.querySelector('.modal__toggle-close_btn'); 
    const headerIconCart = document.querySelector('.header__icon--cart');
    const headerDrawer = document.querySelector('.header-wrapper header-drawer');
    const element = document.querySelector('.announcement-bar-section');
    if (element) element.style.display = 'none'

      
    headerMask.classList.add('show')
    // 常见用途
    this.input && this.input.focus();
    this.onReset();
    
   setTimeout(() => {       
    const triggerElement = document.querySelector('.actived');
    triggerElement.classList.remove('show');
    document.getElementById('header-product-list-pc')?.classList.remove('show');
    document.getElementById('header-blog-list-pc')?.classList.remove('show');
    document.getElementById('header-support-list-pc')?.classList.remove('show');
    document.getElementById('header-explore-list-pc')?.classList.remove('show');
    document.getElementById('show_special_sale')?.classList.remove('show');
  }, 0)

  if (window.innerWidth < 1200) {
    modalToggleOpen.style.display = 'none'
    modalToggleClose.style.display = 'block'
    modalToggleCloseBtn.style.display = 'block'
    headerIconCart.style.display = 'none'
    headerDrawer.style.display = 'none'
  }
  
    // 这里可以：
    // - 播放 GSAP 动画
    // - 加 class
    // - 请求推荐搜索
  }

  onReset(){
    this.input.form.reset();
    const recommendedList = this.parentElement.querySelector('.recommended-search-list');

    if (recommendedList) {
      recommendedList.style.display = 'flex';
    }
    this.predictiveSearchResults.innerHTML = '';

  }

  onSearchClose() {
    console.log('搜索关闭');
    document.getElementById('header-mask')?.classList.remove('show');
    const modalToggleOpen = document.querySelector('.modal__toggle-open'); 
    const modalToggleClose = document.querySelector('.modal__toggle-close'); 
    const modalToggleCloseBtn = document.querySelector('.modal__toggle-close_btn'); 
    const headerIconCart = document.querySelector('.header__icon--cart');
    const headerDrawer = document.querySelector('.header-wrapper header-drawer');
    const element = document.querySelector('.announcement-bar-section');
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (element && scrollTop == 0) element.style.display = 'block'
    if (window.innerWidth < 1200) {
        this.details.removeAttribute('open');
        modalToggleOpen.style.display = 'block';
        modalToggleClose.style.display = 'none';
        modalToggleCloseBtn.style.display = 'none';
        headerIconCart.style.display = 'flex'
        headerDrawer.style.display = 'block'

      }
    // 清空状态 / 停止动画等
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }


  highlightKeyword(text, keyword) {
    if (!keyword) return text;
    const reg = new RegExp(`(${keyword})`, 'gi'); // 忽略大小写
    return text.replace(reg, '<strong class="search-highlight">$1</strong>');
  }

  onChange() {
    this.toggleResetButton();


    const keyword = this.input.value.trim();
    if (!keyword || !this.predictiveSearchResults) return;
    console.log(keyword,this.predictiveSearchResults, 'keyword')
    // 遍历每条预测搜索结果
    this.predictiveSearchResults.querySelectorAll('.predictive-search-item').forEach(item => {
      // const originalText = item.getAttribute('data-original-text') || item.textContent;
      console.log(item)
      // console.log(originalText, 'originalText')
      // // 保存原始文本，避免多次高亮
      // item.setAttribute('data-original-text', originalText);

      // item.innerHTML = this.highlightKeyword(originalText, keyword);
    });


  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
